import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Table, ConfigProvider, Button, Space, Radio, Modal, Spin, message, Tag, Typography, Card, Divider, Tooltip, Dropdown } from 'antd';
import { SearchOutlined, SettingOutlined, DeleteOutlined, ExperimentOutlined, CloseOutlined, WarningOutlined, FileTextOutlined } from '@ant-design/icons';
import { hnrequest } from '@/utils'

import Highlighter from 'react-highlight-words';
import './index.scss'
import zhCN from 'antd/locale/zh_CN';

const { Paragraph, Text } = Typography;
const optionsz1 = [
  { label: '启用', value: 'Y', }, { label: '关闭', value: 'N', }
];
const optionsz2 = [
  { label: '显示', value: 'Y', }, { label: '关闭', value: 'N', }
];




const Dba = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [tdown] = Form.useForm();
  const [tdel] = Form.useForm();
  const [tfvdel] = Form.useForm();
  const [tall] = Form.useForm();





  const [formxf] = Form.useForm();
  const [spinning, setSpinning] = useState(false);
  const [ccpxx, setccpxx] = useState([]);// 选择的产品信息
  const [open, setOpen] = useState(false);
  const [opend, setOpend] = useState(false);
  const [openfvd, setOpenfvd] = useState(false);


  const [openy, setOpeny] = useState(false);
  const [opsetall, setOpensetall] = useState(false);

  const [bangm, setbangm] = useState([]);
  const [ticks, setticks] = useState([]);// 选择的产品信息

  const [lsmx, setChlsmx] = useState([]);



  const onmouseenter = (a) => { setChlsmx(a); }

  const handleMenuClick = e => {
    console.log('click', e.key);
    ppth(lsmx, e.key);
  };


  //  
  const items = [
    {
      key: 'dbpc',
      label: <Space><Paragraph>数据批次:{lsmx.key}</Paragraph></Space>,

    },
    {
      type: 'divider',
    },
    {
      key: 'pno',
      label: <Space><Paragraph copyable={{ text: lsmx.pno }}>产品编号:{lsmx.pno}</Paragraph></Space>,

    },
    {
      key: 'set',
      label: <Space><Button type="primary" icon={<SettingOutlined />} size='small' /> <Button type="link" size='small'>设置参数</Button></Space>,

    },
    {
      key: 'del',
      label: <Space><Button color='orange' variant="filled" icon={<DeleteOutlined />} size='small' /> <Tooltip title="先放回收站，若干时长后自动删除 待更新功能" color='orange'><Button color='orange' variant="filled" size='small'>放回收站</Button></Tooltip></Space>,

    },
    {
      key: 'fvdel',
      label: <Space><Button color='red' variant="solid" icon={<DeleteOutlined />} size='small' /> <Tooltip title="直接永久删除" color='red'><Button color='red' variant="filled" size='small'>永久删除</Button></Tooltip></Space>,

      // extra: '⌘S',
    },
    {
      key: 'setyy',
      label: <Space><Button color='#69b1ff' variant="solid" icon={<ExperimentOutlined />} size='small' disabled={lsmx.plb === "1001" ? false : true} /> <Tooltip title="设置原药信息" color="#69b1ff"><Button color="#69b1ff" variant="filled" size='small' disabled={lsmx.plb === "1001" ? false : true}>原药信息</Button></Tooltip></Space>,
      disabled: lsmx.plb === "1001" ? false : true,

    },
    {
      key: 'setm',
      label: <Space><Button color='green' variant="solid" icon={<FileTextOutlined color='green' />} size='small' /> <Tooltip title="位置预留，更多自由信息添加，仅影响数据批次" color="green"><Button color="green" variant="filled" size='small'>更多信息</Button></Tooltip></Space>,
    },

  ];

  // <FileTextOutlined />

  const toSet = async (e) => {
    setSpinning(true)
    setOpen(false)
    const rq = await hnrequest.post('/pdbset', e)
    setSpinning(false)
    setticks(rq.ticks)
    messageApi.open({ type: rq.return_code, content: rq.return_msg, });

  }


  const toSetall = async (e) => {
    setSpinning(true)
    setOpensetall(false)
    const rq = await hnrequest.post('/pdbsetall', e)
    setSpinning(false)
    setticks(rq.ticks)
    messageApi.open({ type: rq.return_code, content: rq.return_msg, });

  }




  const toDel = async (d) => {
    setSpinning(true)
    setOpend(false)
    const dbd = await hnrequest.post('/pdbdel', d)
    if (dbd.return_code) { setSpinning(false) }
    setticks(dbd.ticks)
    messageApi.open({ type: dbd.return_code, content: dbd.return_msg, });
    // dbd.return_code === "success" && setbangm(bangm.filter(item => item.key !== d.dbno))
  }



  // 

  const tofvDel = async (d) => {
    setSpinning(true)
    setOpenfvd(false)
    const dbd = await hnrequest.post('/pdbfvdel', d)
    if (dbd.return_code) { setSpinning(false) }
    setticks(dbd.ticks)
    messageApi.open({ type: dbd.return_code, content: dbd.return_msg, });
    // dbd.return_code === "success" && setbangm(bangm.filter(item => item.key !== d.dbno))
  }





  useEffect(() => {
    setSpinning(true)
    async function getau() {
      const res = await hnrequest.post('/pdb_list', { ticks: ticks })
      setSpinning(false)
      setbangm(res.rescode)
    }
    getau()
  }, [ticks])

  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`检索内容`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            检索
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            重置
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            关闭
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });


  const ppth = (e, f) => {
    setccpxx(e)
    f === "del" && setOpend(true)
    f === "fvdel" && setOpenfvd(true)
    f === "set" && setOpen(true)
    const dbnoj = { dbno: e.key };
    const formjson = Object.assign(e.setj[0], dbnoj);
    console.log(formjson);

    f === "set" && tdown.setFieldsValue(formjson)
    f === "del" && tdel.setFieldsValue(formjson)
    f === "fvdel" && tfvdel.setFieldsValue({ dbno: e.key, sm: "" })
    f === "setyy" && setOpeny(true)
    f === "setyy" && formxf.setFieldsValue({ dbno: e.key })
    f === "setyy" && e.sjson.dyyjson !== undefined && formxf.setFieldsValue({ yyjson: e.sjson.dyyjson })
    f === "setyy" && e.sjson.dyyjson === undefined && formxf.setFieldsValue({ yyjson: "" })
    // console.log(f, e.key,"d="+JSON.stringify(formjson))
  }
  const onFxfsq = async (e) => {
    const rq = await hnrequest.post('/p_adyyxx', e)

    setOpeny(false)
    setticks(rq.ticks)
    messageApi.open({ type: rq.return_code, content: rq.return_msg, });
  }



  const columns = [


    {
      title: <Space><Tooltip title="全局设置" color='blue' ><Button type="primary" icon={<SettingOutlined />} size='small' onClick={() => setOpensetall(true)}/></Tooltip>数据批号</Space>,
      dataIndex: 'key',
      ...getColumnSearchProps('key'),
      key: 'key',
      sorter: (a, b) => a.key - b.key,
      sortDirections: ['descend', 'ascend'],
      render: (_, record) => (
        <Dropdown menu={{ items, onClick: handleMenuClick, }} onMouseEnter={() => { onmouseenter(record) }} >{record.key}</Dropdown>
      ),
    },
    {
      title: '类型',
      dataIndex: 'plb',
      key: 'plb',
      render: (_, record) => (
        <Space size="small">
          {record.dblx === "outdb" && <Tag color="#108ee9" >Group</Tag>}
          {record.dblx === "indb" && <Tag color="#87d068" >Single</Tag>}
          {record.plb === "1001" && <Tag color="volcano" >农药</Tag>}
          {record.plb === "1003" && <Tag color="green" >种子</Tag>}
          {record.plb === "1002" && <Tag color="purple" >农肥&其他</Tag>}
          {record.plb === "1004" && <Tag color="purple" >农肥&其他</Tag>}
        </Space>
      ),
    },
    {
      title: '产品名称',
      key: 'pname',
      dataIndex: 'pname',
    },
    {
      title: '生成时间',
      dataIndex: 'scsj',
      key: 'scsj',
      sorter: (a, b) => a.key - b.key,
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('scsj'),
    },
    {
      title: '数量',
      dataIndex: 'db_total',
      key: 'db_total',
    },
    {
      title: '下载次数',
      dataIndex: 'db_ds',
      key: 'db_ds',
    },

  ];







  return (
    <>


      <ConfigProvider locale={zhCN} >
        {contextHolder}
        <Table size="small"
          // rowSelection={   {type:"checkbox",...rowSelection,}} 
          columns={columns} dataSource={bangm} />

        <Modal
          title="数据信息"
          centered
          open={open}
          footer={false}
          width={680}
          onOk={() => setOpen(false)}
          onCancel={() => setOpen(false)}
        >
          <Paragraph>产品名称:{ccpxx.pname}  <Text>数据批号:{ccpxx.key}</Text> </Paragraph>


          <Form form={tdown} onFinish={toSet}>
            <Form.Item name="dbno" hidden="true"><Input /></Form.Item>
            <Space.Compact>
              <Space>

                <Form.Item label="激活状态" name="jh_zt"
                >
                  <Radio.Group
                    options={optionsz1}
                    optionType="button"
                    size="small"
                  />
                </Form.Item>

                <Form.Item label="扫描次数" name="s_cs"
                >
                  <Radio.Group
                    options={optionsz2}
                    optionType="button"
                    size="small"
                  />
                </Form.Item>


                <Form.Item label="定位信息" name="s_dw"
                >
                  <Radio.Group
                    options={optionsz2}
                    optionType="button"
                    size="small"
                  />
                </Form.Item>

              </Space>
            </Space.Compact>


            <Space.Compact>


              <Space>


                <Form.Item label="流转信息" name="s_lz"
                >
                  <Radio.Group
                    options={optionsz2}
                    optionType="button"
                    size="small"
                  />
                </Form.Item>


                <Form.Item label="启用状态" name="s_qy"
                >
                  <Radio.Group
                    options={optionsz1}
                    optionType="button"
                    size="small"
                  />


                </Form.Item>

                <Form.Item label="验证互动" name="s_yz"
                >
                  <Radio.Group
                    options={optionsz1}
                    optionType="button"
                    size="small"
                  />
                </Form.Item>

              </Space>




            </Space.Compact>








            <Space.Compact block>
              <Tooltip title="成对显示，若有一项为空则不会显示" color='orange'><Form.Item name="sc_b1t" style={{ width: '30%' }} ><Input placeholder="生产日期标题" allowClear /></Form.Item></Tooltip>
              <Tooltip title="成对显示，若有一项为空则不会显示" color='orange'><Form.Item name="sc_b1" style={{ width: '70%' }} ><Input placeholder="具体的生产日期" allowClear /></Form.Item></Tooltip>
            </Space.Compact>

            <Space.Compact block>
              <Tooltip title="成对显示，若有一项为空则不会显示" color='orange'><Form.Item name="sc_b2t" style={{ width: '30%' }}><Input placeholder="生产批次标题" allowClear /></Form.Item></Tooltip>
              <Tooltip title="成对显示，若有一项为空则不会显示" color='orange'><Form.Item name="sc_b2" style={{ width: '70%' }}><Input placeholder="具体的生产批次" allowClear /></Form.Item></Tooltip>
            </Space.Compact>
            <Space.Compact block>
              <Tooltip title="成对显示，若有一项为空则不会显示" color='orange'><Form.Item name="sc_b3t" style={{ width: '30%' }}><Input placeholder="备用标题" allowClear /></Form.Item></Tooltip>
              <Tooltip title="成对显示，若有一项为空则不会显示" color='orange'><Form.Item name="sc_b3" style={{ width: '70%' }}><Input placeholder="填写内容" allowClear /></Form.Item></Tooltip>
            </Space.Compact>




            <Form.Item >
              <Button type="primary" htmlType="submit" block>
                设 置
              </Button>
            </Form.Item>

          </Form>




        </Modal>

        {/* 全局设置 */}

        <Modal
          title="全局设置"
          centered
          open={opsetall}
          footer={false}
          width={680}
          onOk={() => setOpensetall(false)}
          onCancel={() => setOpensetall(false)}
        >
          <Form form={tall} onFinish={toSetall}>
            <Form.Item name="dbno" hidden="true"><Input /></Form.Item>

            <Paragraph copyable type="danger">我知晓此操作将会影响以往所有数据，确定需要使用批量修改并为此操作后果负责！</Paragraph>
            <Form.Item name="sm" label='免责声明'
              rules={[{ required: true, message: '请输入免责声明!' }]}
            ><Input /></Form.Item>

            <Space.Compact block>
              <Tooltip title="成对显示，若有一项为空则不会显示" color='orange'><Form.Item name="sc_b1t" style={{ width: '30%' }} ><Input placeholder="生产日期标题" allowClear /></Form.Item></Tooltip>
              <Tooltip title="成对显示，若有一项为空则不会显示" color='orange'><Form.Item name="sc_b1" style={{ width: '70%' }} ><Input placeholder="具体的生产日期" allowClear /></Form.Item></Tooltip>
            </Space.Compact>

            <Space.Compact block>
              <Tooltip title="成对显示，若有一项为空则不会显示" color='orange'><Form.Item name="sc_b2t" style={{ width: '30%' }}><Input placeholder="生产批次标题" allowClear /></Form.Item></Tooltip>
              <Tooltip title="成对显示，若有一项为空则不会显示" color='orange'><Form.Item name="sc_b2" style={{ width: '70%' }}><Input placeholder="具体的生产批次" allowClear /></Form.Item></Tooltip>
            </Space.Compact>
            <Space.Compact block>
              <Tooltip title="成对显示，若有一项为空则不会显示" color='orange'><Form.Item name="sc_b3t" style={{ width: '30%' }}><Input placeholder="备用标题" allowClear /></Form.Item></Tooltip>
              <Tooltip title="成对显示，若有一项为空则不会显示" color='orange'><Form.Item name="sc_b3" style={{ width: '70%' }}><Input placeholder="填写内容" allowClear /></Form.Item></Tooltip>
            </Space.Compact>




            <Form.Item >
              <Button type="primary" htmlType="submit" block>
                设 置
              </Button>
            </Form.Item>

          </Form>




        </Modal>





        {/*  */}

        <Modal
          title="原药信息维护"
          footer={null}
          style={{ top: 58 }}
          open={openy}
          // onOk={() => onFxfsq()}
          onCancel={() => setOpeny(false)}
          width={1200}
        >



          <Form
            name="dbxfsq"
            layout="horizontal"
            onFinish={onFxfsq}
            form={formxf}
          >
            <Form.Item name='dbno'
              hidden={true}
            >
              <Input />
            </Form.Item>
            <Form.List name="yyjson" >



              {(fields, { add, remove }) => (


                <div
                  style={{
                    display: 'flex',
                    rowGap: 16,
                    flexDirection: 'column',
                  }}
                >
                  <Space>
                    数据批号：{ccpxx.key} 产品名称：{ccpxx.pname} <Tag icon={<ExperimentOutlined />} color="#69b1ff" onClick={() => add()} > + 原药信息</Tag>

                  </Space>




                  {fields.map((field) => (
                    <Card
                      size="small"
                      title={`原药信息 ${field.name + 1}`}
                      key={field.key}
                      extra={
                        <CloseOutlined
                          onClick={() => {
                            remove(field.name);
                          }}
                        />
                      }
                    >
                      <Form.Item label="">
                        <Form.List name={[field.name, 'ymsglist']}>
                          {(subFields, subOpt) => (
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                rowGap: 16,
                              }}
                            >
                              {subFields.map((subField) => (
                                <Space key={subField.key}>
                                  <Form.Item
                                    rules={[{ required: true, message: '该信息不能为空!' }]}
                                    name={[subField.name, 'mc']}>
                                    <Input placeholder="类目名称" count={{ show: true, }} allowClear />
                                  </Form.Item>
                                  <Form.Item
                                    rules={[{ required: true, message: '该信息不能为空!' }]}
                                    name={[subField.name, 'nr']}>
                                    <Input placeholder="内容" style={{ width: "400px" }} count={{ show: true, }} allowClear />
                                  </Form.Item>
                                  <CloseOutlined
                                    onClick={() => {
                                      subOpt.remove(subField.name);
                                    }}
                                  />
                                </Space>
                              ))}
                              <Button type="dashed" onClick={() => subOpt.add()} >
                                + 添加项目
                              </Button>
                            </div>
                          )}
                        </Form.List>
                      </Form.Item>
                    </Card>
                  ))}
                </div>
              )}
            </Form.List>

            <Form.Item>
              <Button type="primary"
                htmlType="submit"
                style={{ marginTop: "20px" }}
                block={true} >
                提   交
              </Button>
            </Form.Item>
          </Form>
        </Modal>

        {/*  */}


        <Modal
          title="删除数据"
          centered
          open={opend}
          footer={false}
          onOk={() => setOpend(false)}
          onCancel={() => setOpend(false)}
        >
          <Divider titlePlacement="start" plain style={{ borderColor: '#7cb305' }}>
            15日内允许撤回
          </Divider>
          <Paragraph>产品名称:{ccpxx.pname}  <Text>数据批号:{ccpxx.key}</Text> </Paragraph>
          <Form form={tdel} onFinish={toDel}>

            <Form.Item name="dbno" hidden="true"><Input /></Form.Item>

            <Form.Item >
              <Button type="primary" htmlType="submit" block>
                提 交
              </Button>
            </Form.Item>

          </Form>

        </Modal>


        {/*  */}

        <Modal
          title="永久删除数据"
          centered
          open={openfvd}
          footer={false}
          onOk={() => setOpenfvd(false)}
          onCancel={() => setOpenfvd(false)}
        >
          <Paragraph>产品名称:{ccpxx.pname}  <Text>数据批号:{ccpxx.key}</Text> </Paragraph>
          <Paragraph copyable type="danger">我知晓此操作为直接删除数据可能会影响市场存货的销售及知晓恢复操作需要支付相关费用，并确定需要删除此批次数据！并为此操作后果负责！</Paragraph>
          <Form form={tfvdel} onFinish={tofvDel}>

            <Form.Item name="dbno" hidden="true"><Input /></Form.Item>
            <Form.Item name="sm" label='免责声明'
              rules={[{ required: true, message: '请输入免责声明!' }]}
            ><Input /></Form.Item>

            <Form.Item >
              <Button type="primary" danger htmlType="submit" block icon={<WarningOutlined />}>
                确定及肯定必须删除
              </Button>
            </Form.Item>

          </Form>

        </Modal>

        {/*  */}

        <Spin spinning={spinning} tip="数据整理中，请稍等..." fullscreen />

      </ConfigProvider>
    </>

  );
};
export default Dba;